import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import Notification from '../Noti/Noti';
import { httpss } from '../../utils/host';
import axios from 'axios';
import logoMyH from '../../assets/images/logo-myH.png'

export default function User() {
  const [isSync, setIsSync] = useState(false)
  const accessToken = sessionStorage.getItem('accessToken');
  const [notification, setNotification] = useState(null);
  const showNotification = (message) => {setNotification({ message })};
  const handleCloseNotification = () => {setNotification(null)};

  // const httpss = 'http://localhost:5005';

  const [data, setData] = useState([]);
  const [filter, setFilter] = useState('');
  const [totalData, setTotalData] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  // const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [sortConfig, setSortConfig] = useState({ key: 'updatedAt', direction: 'desc' }); // Mặc định thời gian updatedAt lên trên

  const [selectedAction, setSelectedAction] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const columnsToShow = ["displayName","businessPhones","givenName","jobTitle","mail","mobilePhone","officeLocation","preferredLanguage","surname","userPrincipalName","photo","FacebookName","updatedAt","createdAt"];

  useEffect(() => {
    getData()
  },[currentPage, itemsPerPage])

  useEffect(() => {  // tối ưu thanh tìm kiếm
    const timer = setTimeout(() => {
      getData();
    }, 1000); 

    return () => clearTimeout(timer); 
  }, [filter]);

  const getData = async () => {
    const queryParams = new URLSearchParams({
      page: currentPage,
      pageSize: itemsPerPage,
      sortOrder: sortConfig.direction,
      filter: filter, // Điều kiện tìm kiếm
    });
  
    fetch(`${httpss}/apis_v1/admin/getDataUser?${queryParams.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        setData(data.data);
        setTotalData(data.totalItems) // Tổng số đăng ký
        setTotalPages(data.totalPages); // Lưu tổng số trang
      })
      .catch(error => {
        console.error('Error fetching data:', error)
        // sessionStorage.clear();
        // window.location.reload();
      });
  };

  const handleDeleteSelected = async () => {  //Xóa thí sinh
    if (window.confirm(`Bạn có chắc chắn muốn xóa ${selectedItems.length} mục đã chọn không?`)) {
      exportSelectedItem();
      try {
        await fetch(`${httpss}/apis_v1/admin/delete_items`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ids: selectedItems }), // Thay 'ids' bằng tham số mà API của bạn yêu cầu
        });
        setData(prevData => prevData.filter(item => !selectedItems.includes(item.id))); // Thay 'id' bằng trường ID của dữ liệu của bạn
        setSelectedItems([]);
        showNotification('Đã xóa các mục đã chọn');
      } catch (error) {
        console.error('Error deleting items:', error);
      }
    }
  };
  
  const exportToExcel = async () => {
    let exportData = data
    const response = await fetch(`${httpss}/apis_v1/admin/exportAll`);
    const result = await response.json();
    exportData = result;

    if (exportData) {
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, 'export-All.xlsx');
    }
    showNotification('Dữ liệu đã được tải về');
  };

  const exportSelectedItem = () => {
    if (selectedItems.length > 0) {
      const selectedData = data.filter(item => selectedItems.includes(item.id));
      const ws = XLSX.utils.json_to_sheet(selectedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, 'export-Selected.xlsx');
      showNotification('Dữ liệu đã được tải về');
    } else {
      showNotification('Không có mục nào được chọn');
    }
  };
  

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedAction(value);

    if (value === 'export') {
      exportSelectedItem();
      setSelectedAction('')
    }else if (value === 'exportAll') {
      exportToExcel();
      setSelectedAction('')
    } else if (value === 'syncUser') {
      handleSyncUser()
    } else if (value === 'syncUser_Images') {
      handleSyncUserImages()
    } else if (value === 'delete') {
      handleDeleteSelected();
      setSelectedAction('')
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedItems(prevSelectedItems => {
      if (prevSelectedItems.includes(id)) {
        return prevSelectedItems.filter(item => item !== id);
      } else {
        return [...prevSelectedItems, id];
      }
    });
  };
  
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      const currentPageItems = data.map(item => item.id); // Chỉ chọn các mục trên trang hiện tại
      setSelectedItems(prevSelectedItems => {
        const newSelectedItems = new Set([...prevSelectedItems, ...currentPageItems]);
        return Array.from(newSelectedItems);
      });
    } else {
      setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => !data.some(ci => ci.id === item)));
    }
  };
  

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = [...data].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const handleSearchChange = (e) => {
    setFilter(e.target.value);
    setCurrentPage(1);
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  const renderPageNumbers = () => {
    const pageList = [];
    const totalPages = pageNumbers.length;
    const siblingCount = 1;
    const firstPageIndex = 1;
    const lastPageIndex = totalPages;

    if (totalPages <= 10) {
      return pageNumbers.map(number => (
        <button key={number} onClick={() => handlePageChange(number)}
          className={`mx-1 px-3 py-1 border rounded ${currentPage === number ? 'bg-sky-500 text-white' : 'bg-white text-sky-500'}`}>
          {number}
        </button>
      ));
    }

    const createPageButton = (page) => (
      <button key={page} onClick={() => handlePageChange(page)}
        className={`mx-1 px-3 py-1 border rounded ${currentPage === page ? 'bg-sky-500 text-white' : 'bg-white text-sky-500'}`}>
        {page}
      </button>
    );

    const createEllipsis = (key) => (
      <span key={key} className="mx-1 px-3 py-1 border rounded">
        ...
      </span>
    );

    pageList.push(createPageButton(firstPageIndex));

    if (currentPage > 2 + siblingCount) {
      pageList.push(createEllipsis('leftEllipsis'));
    }

    const startPage = Math.max(currentPage - siblingCount, 2);
    const endPage = Math.min(currentPage + siblingCount, totalPages - 1);

    for (let i = startPage; i <= endPage; i++) {
      pageList.push(createPageButton(i));
    }

    if (currentPage < totalPages - 1 - siblingCount) {
      pageList.push(createEllipsis('rightEllipsis'));
    }

    pageList.push(createPageButton(lastPageIndex));

    return pageList;
  };

  const handleSyncUser = async () => {
    setIsSync(true);
    const accessToken = sessionStorage.getItem('accessToken');
    
    try {
      const postUrl = `${httpss}/apis_v1/admin/syncDataUser`;
      const res = await axios.post(postUrl, { accessToken }, {
        headers: { "Content-Type": "application/json" }
      });
      
      if (res.status >= 200 && res.status < 300) {
        alert('Đồng bộ thành công');
      } else {
        alert('Đồng bộ không thành công');
      }
    } catch (err) {
      console.error("Error syncing user data:", err);
      alert('Đồng bộ không thành công');
      // sessionStorage.clear();
      // window.location.reload();
    } finally {
      setIsSync(false);
      setSelectedAction('')
    }
  };

  const handleSyncUserImages = async () => {
    setIsSync(true);
    const accessToken = sessionStorage.getItem('accessToken');
    
    try {
      const postUrl = `${httpss}/apis_v1/admin/syncDataUser_Images`;
      const res = await axios.post(postUrl, { accessToken, id:selectedItems }, {
        headers: { "Content-Type": "application/json" }
      });
      
      if (res.status >= 200 && res.status < 300) {
        alert('Đồng bộ hình ảnh thành công');
      } else {
        alert('Đồng bộ hình ảnh không thành công');
      }
    } catch (err) {
      console.error("Error syncing user data:", err);
      alert('Đồng bộ không thành công');
      // sessionStorage.clear();
      // window.location.reload();
    } finally {
      setIsSync(false);
      setSelectedAction('')
    }
  };

  return (
    <div className="flex flex-col h-screen max-md:h-[85vh]">
      {notification && (<Notification message={notification.message} onClose={handleCloseNotification} />)}
      <div className='md:flex justify-end m-1'>
        <div className='w-full hover:bg-gray-300' onClick={getData}>
          <div className='flex max-md:justify-center max-md:items-end md:items-center'>
          {selectedItems.length>0&&<p className='text-nowrap mx-2'>Chọn {selectedItems.length}</p>}
            <div className='md:w-full flex justify-center'>
              <p className='text-blue-900 text-xl font-bold'>DANH SÁCH USER 365</p>
            </div>
            <p className='text-nowrap mx-2'>Tổng {totalData}</p>
          </div>
        </div>
        <div className='flex items-center gap-2'>
          <input type='search' placeholder='Tìm kiếm...' value={filter} onChange={handleSearchChange} className='max-md:w-full border px-2 outline-none rounded' />
          <select value={selectedAction} onChange={handleSelectChange} className='text-nowrap bg-blue-300 px-5 outline-none rounded text-white font-bold hover:bg-blue-300/90'>
            <option value="" disabled>Hành động</option>
            <option value="syncUser" disabled={isSync?true:false}>{isSync?'Đang đ':'Đ'}ồng bộ data{isSync?'...':''}</option>
            <option value="syncUser_Images" disabled={isSync?true:false}>{isSync?'Đang đ':'Đ'}ồng bộ ảnh{isSync?'...':''}</option>
            {/* <option value="export">Xuất đã chọn</option> */}
            {/* <option value="exportAll">Xuất tất cả</option> */}
            {/* <option value="delete">Xóa</option> */}
          </select>
        </div>
      </div>
      <div className='flex-grow overflow-auto'>
        <table className='w-full text-xs'>
          <thead className='bg-gray-200 text-gray-700 font-bold sticky -top-1 z-0 shadow'>
            <tr>
              <th className='border p-1 text-center'>
                <input type='checkbox' onChange={handleSelectAllChange} 
                checked={sortedData.every(item => selectedItems.includes(item.id)) && sortedData.length > 0}/>
              </th>
              <th>STT</th>
              {columnsToShow.map((key) => (
                <th key={key} className='border cursor-pointer' onClick={() => handleSort(key)}>
                  {key} {sortConfig.key === key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.isArray(sortedData) && sortedData.map((item, index) => (
              <tr key={index} className='hover:bg-gray-100'>
              <th className='border p-1 text-center'>
                <input type='checkbox'  
                onChange={() => handleCheckboxChange(item.id)}
                checked={selectedItems.includes(item.id)}
                />
              </th>
              <td className='border px-1 text-center'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              {/* <td className='border p-1 text-center'>{item.id}</td>  */}
                {columnsToShow.map((key, i) => (
                  <td key={i} className='border px-1 text-center'>
                    {key === 'photo'? 
                      (
                        <div className="group inline-block">
                          {item[key] == null ? (
                            <img src={logoMyH} alt="photo" className="w-7 h-7 rounded-full group-hover:opacity-75 transition-opacity duration-200" />
                          ):(
                            <div>
                            <img src={`data:image/png;base64,${item[key]}`} alt="photo" className="w-7 h-7 rounded-full group-hover:opacity-75 transition-opacity duration-200" />
                            <div className="fixed hidden group-hover:flex items-center justify-center top-1/2 left-[70%] transform -translate-x-1/2 -translate-y-1/2 z-10">
                              <img src={`data:image/png;base64,${item[key]}`} alt="large photo" className="w-96 h-96 rounded-lg shadow-lg" />
                            </div>
                          </div>
                          )}
                        </div>
                      )
                      : item[key]
                    }
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
        <div className='sticky bottom-0 z-0 flex justify-center m-1 p-1'>
          {renderPageNumbers()}
          <select className='outline-none border' onChange={handleItemsPerPageChange} value={itemsPerPage}>
            <option value={50}>50 / trang</option>
            <option value={100}>100 / trang</option>
            <option value={200}>200 / trang</option>
            <option value={1000}>1000/ trang</option>
          </select>
        </div>
    </div>
  );
}
